import React, {Component} from "react";
import {Modal, ModalBody} from "reactstrap";

export class LoadingDialog extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen || false}
             className={'modal-lg ' + this.props.className}>
        <ModalBody>
          <div style={{textAlign: "center"}}><h2>Loading</h2>
          </div>
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Shared/LoadingDialog.js